module.exports = __webpack_public_path__ + "assets/img/National-Media-Social-Static-Ad-w960.d60c7cca.webp";